import { useTexts } from "Store/texts";
import React from "react";

export const WrongInfo = (): React.ReactElement => {
  const fmsTexts = useTexts();
  return (
    <div
      style={{ display: "flex", flexDirection: "column", marginTop: "24px" }}
    >
      <b>{fmsTexts.domain["signedInUserInfo.wrongInfo.title"]}</b>
      <span className="hint">
        {fmsTexts.domain["signedInUserInfo.wrongInfo.description"]}
      </span>
    </div>
  );
};
